module.exports = {
  messages: {
    CN: {
      'sendtypesetting.sendtypeName': '运输方式',
      'sendtypesetting.sendtypeNew': '新建运输方式',
      'sendtypesetting.sendtypeEdit': '编辑运输方式',
      'sendtypesetting.goodsNum': '商品数量',
      'sendtypesetting.pictureUrl': '运输方式图片'
    },
    JP: {
      'sendtypesetting.sendtypeName': '配達方法',
      'sendtypesetting.sendtypeNew': '新しい配達方法を作成',
      'sendtypesetting.sendtypeEdit': '配達方法を編集',
      'sendtypesetting.goodsNum': '商品数量',
      'sendtypesetting.pictureUrl': '配達方法画像'
    }
  }
};